export type ExpenseSort = 'default' | 'spent' | 'name' | 'limit' | 'progress';

export interface DashboardPreferences {
  hiddenCategoryIds: string[];
  hiddenBudgetIds: string[];
  expenseSort: ExpenseSort;
}

export const defaultDashboardPreferences: DashboardPreferences = {
  hiddenCategoryIds: [],
  hiddenBudgetIds: [],
  expenseSort: 'default',
};

export function preferencesKey(userId: string, workspaceId: string): string {
  return `kazna:dashboard:${userId}:${workspaceId}`;
}

export function loadPreferences(userId: string, workspaceId: string): DashboardPreferences {
  try {
    const value = JSON.parse(
      localStorage.getItem(preferencesKey(userId, workspaceId)) ?? 'null',
    ) as Partial<DashboardPreferences> | null;
    return {
      hiddenCategoryIds: stringArray(value?.hiddenCategoryIds),
      hiddenBudgetIds: stringArray(value?.hiddenBudgetIds),
      expenseSort: normalizeExpenseSort(value?.expenseSort),
    };
  } catch {
    return defaultDashboardPreferences;
  }
}

export function savePreferences(
  userId: string,
  workspaceId: string,
  value: DashboardPreferences,
): void {
  localStorage.setItem(preferencesKey(userId, workspaceId), JSON.stringify(value));
}

function stringArray(value: unknown): string[] {
  return Array.isArray(value) ? value.filter(item => typeof item === 'string') : [];
}

function normalizeExpenseSort(value: unknown): ExpenseSort {
  if (value === 'amount') return 'spent';
  if (
    value === 'default' ||
    value === 'spent' ||
    value === 'name' ||
    value === 'limit' ||
    value === 'progress'
  ) {
    return value;
  }
  return 'default';
}
